if (!customElements.get('article-product-slider')) {
  class ArticleProductSlider extends HTMLElement {
    static selectors = {
      arrows: {
        left: '.arrow-left',
        right: '.arrow-right',
      },
      slider: '.swiper',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderElement = this.querySelector(
        ArticleProductSlider.selectors.slider,
      );

      this.settings = {
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        spaceBetween: 12,
        navigation: {
          prevEl: this.querySelector(
            ArticleProductSlider.selectors.arrows.left,
          ),
          nextEl: this.querySelector(
            ArticleProductSlider.selectors.arrows.right,
          ),
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1080: {
            slidesPerView: 5,
          },
        },
      };

      this.slider = new Swiper(this.sliderElement, this.settings);
    }
  }

  customElements.define('article-product-slider', ArticleProductSlider);
}
